var map = {
	"./damiano_cavazzana.jpg": "./app/javascript/assets/images/authors/damiano_cavazzana.jpg",
	"./dario_menin.jpg": "./app/javascript/assets/images/authors/dario_menin.jpg",
	"./davide_disomma.jpg": "./app/javascript/assets/images/authors/davide_disomma.jpg",
	"./federico_gobbo.jpg": "./app/javascript/assets/images/authors/federico_gobbo.jpg",
	"./giacomo_macri.jpg": "./app/javascript/assets/images/authors/giacomo_macri.jpg",
	"./marco_galvagni.jpg": "./app/javascript/assets/images/authors/marco_galvagni.jpg",
	"./michele_minazzato.jpg": "./app/javascript/assets/images/authors/michele_minazzato.jpg",
	"./nosco_team.jpg": "./app/javascript/assets/images/authors/nosco_team.jpg",
	"./paolo_brasolin.jpg": "./app/javascript/assets/images/authors/paolo_brasolin.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/images/authors sync recursive \\.jpg$";